import { render, staticRenderFns } from "./addnew_accessory.vue?vue&type=template&id=1f9665d4&"
import script from "./addnew_accessory.vue?vue&type=script&lang=js&"
export * from "./addnew_accessory.vue?vue&type=script&lang=js&"
import style0 from "./addnew_accessory.vue?vue&type=style&index=0&id=1f9665d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports